// components/DatePresets.tsx
import React from 'react';
import DateInput from './DateInput';
import { SingleDateInputProps, RangeDateInputProps } from '../../models/date.types';

// Type-safe single date (date-only)
export const SimpleDateInput: React.FC<Omit<SingleDateInputProps, 'mode' | 'type'> & {
    label?: string;
}> = ({ label = 'Date', ...props }) => {
    return (
        <DateInput
            mode="single"
            type="date"
            {...props}
            labels={{ single: label }}
        />
    );
};

// Type-safe single datetime
export const SimpleDateTimeInput: React.FC<Omit<SingleDateInputProps, 'mode' | 'type'> & {
    label?: string;
}> = ({ label = 'Date & Time', ...props }) => {
    return (
        <DateInput
            mode="single"
            type="datetime"
            {...props}
            labels={{ single: label }}
        />
    );
};

// Type-safe date range (date-only)
export const DateRangeInput: React.FC<Omit<RangeDateInputProps, 'mode' | 'type'> & {
    startLabel?: string;
    endLabel?: string;
}> = ({ startLabel = 'From', endLabel = 'To', ...props }) => {
    return (
        <DateInput
            mode="range"
            type="date"
            {...props}
            labels={{ start: startLabel, end: endLabel }}
        />
    );
};

// Type-safe datetime range
export const DateTimeRangeInput: React.FC<Omit<RangeDateInputProps, 'mode' | 'type'> & {
    startLabel?: string;
    endLabel?: string;
}> = ({ startLabel = 'Start', endLabel = 'End', ...props }) => {
    return (
        <DateInput
            mode="range"
            type="datetime"
            {...props}
            labels={{ start: startLabel, end: endLabel }}
        />
    );
};

// Specialized due date component
export const DueDateInput: React.FC<{
    value: string;
    onChange: (date: string) => void;
    showTime?: boolean;
    disabled?: boolean;
    label?: string;
}> = ({ value, onChange, showTime = false, disabled = false, label }) => {
    const actualLabel = label || (showTime ? 'Due Date & Time' : 'Due Date');

    return (
        <DateInput
            mode="single"
            type={showTime ? 'datetime' : 'date'}
            value={value}
            onChange={onChange}
            labels={{ single: actualLabel }}
            disabled={disabled}
            required
        />
    );
};